import Vue from "vue"
import VueI18n from "vue-i18n"
import App from "./App.vue"
import api from "./api"
import router from "./router"
import store from "./store"
import _ from "lodash"
import moment from "moment"
import i18n from "./i18n"
import "./filters"

Vue.config.productionTip = false
Vue.config.API_URL = process.env.VUE_APP_API_URL

// Add global bindings. Example: Vue.$_.map
Object.defineProperty(Vue.prototype, "$_", { value: _ })
Object.defineProperty(Vue.prototype, "$moment", { value: moment })
Object.defineProperty(Vue.prototype, "api", { value: api })
Object.defineProperty(Vue.prototype, "docsResource", {
  value: function(fileName) {
    if (!fileName) return null

    const [name, ext] = fileName.split(".")
    return require(`@/docs/assets/${name}.${ext}`)
  },
})

Vue.use(VueI18n)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount("#app")
